import React from 'react';
import { Link } from 'react-router-dom';

const SolutionsOverview = () => {
  const solutions = [
    {
      image: '/images/curved/18.pic.jpg',
      alt: 'Luxury residential elevator interior, modern design, premium materials, architectural photography',
      icon: 'fa-home',
      title: 'Curved Stair',
      route: '/curved_stair',
      features: [
        'Steel belt traction main machine',
        'iCtrl control cabine',
        'Absolute position control system'
      ]
    },
    {
      image: '/images/straight/1.jpg',
      alt: 'Commercial building elevator system, modern office lobby, professional architecture, glass and steel',
      icon: 'fa-building',
      title: 'Straight Stair',
      route: '/straight_stair',
      features: [
        'ARD power failure protection',
        'One-button call for help',
        'Self-service rescue in the lift'
      ]
    },
    {
      image: '/images/floating/6.pic.jpg',
      alt: 'Luxury curved staircase with glass railings, modern architectural design, premium materials, elegant lighting',
      icon: 'fa-stairs',
      title: 'Floating Stair',
      route: '/floating_stair',
      features: [
        'Control box function',
        'Child Lock',
        'VIP Floor Lock'
      ]
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-premium-gold text-sm font-semibold tracking-widest uppercase">Staircase Solutions</span>
          </div>
          <h2 className="font-display text-5xl font-bold text-premium-dark mb-6">
          Functional art for every level<br />Elevating your perspective, one step at a time
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Fundamental architectural feature designed to bridge the vertical gap between different levels, transforming a climb into a rhythmic series of manageable steps. Beyond their simple utility, stairs serve as a focal point for interior design, ranging from grand, sweeping marble flights to sleek, minimalist spirals that save space while adding a touch of modern flair.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {solutions.map((solution, index) => (
            <Link 
              key={index} 
              to={solution.route}
              className="group relative overflow-hidden bg-premium-light hover:shadow-2xl transition-all duration-500 block cursor-pointer"
            >
              <div className="h-80 overflow-hidden">
                <img
                  src={solution.image}
                  alt={solution.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-premium-dark via-premium-dark/10 to-transparent opacity-80"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-8">
                <div className="flex items-center space-x-3 mb-1">
                 
                  <h3 className="font-display text-lg sm:text-l lg:text-xl font-bold text-white break-words">{solution.title}</h3>
                </div>
               
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsOverview;
